import { cn } from '@/lib/utils';

interface CheckboxRowProps {
  id: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  disabled?: boolean;
}

export default function CheckboxRow({
  id,
  checked,
  onChange,
  label,
  disabled,
}: CheckboxRowProps) {
  return (
    <label
      htmlFor={id}
      className={cn(
        'flex items-center gap-2 text-xs select-none cursor-pointer',
        disabled && 'opacity-50 cursor-not-allowed',
      )}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="rounded border-border"
      />
      {label}
    </label>
  );
}
